import { render, staticRenderFns } from "./homeOtherTask.vue?vue&type=template&id=47b6920a&"
import script from "./homeOtherTask.vue?vue&type=script&lang=js&"
export * from "./homeOtherTask.vue?vue&type=script&lang=js&"
import style0 from "./homeOtherTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports